import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";
import { PRODUCT_CARDS } from "appLauncher";

const Section = styled.section`
  background: #f8f8f8;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 49px;
`;

const CardGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 32px;
  justify-content: center;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
`;

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  background: #fff;
  border: none;
  box-shadow: none;
  width: 588px;
  height: 179px;
  padding: 32px;
  border-radius: 16px;
`;

const CardIcon = styled.div`
  width: 116px;
  height: 116px;
  border-radius: 16px;
  margin-right: 24px;
  flex-shrink: 0;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px;
`;

const CardTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #1b2532;
  margin-bottom: 12px;
`;

const CardDesc = styled.div`
  font-size: 14px;
  color: #555;
  line-height: 22px;
`;

export default function ProductDescription() {
  return (
    <Section>
      <SectionTitle>产品说明</SectionTitle>
      <SectionSubtitle>Product Description</SectionSubtitle>
      <CardGroup>
        {PRODUCT_CARDS.map((card, idx) => (
          <Card key={idx}>
            <CardIcon>
              <img src={"/assets/product/text-" + (idx + 1) + ".png"} />
            </CardIcon>
            <CardContent>
              <CardTitle>{card.title}</CardTitle>
              <CardDesc>{card.desc}</CardDesc>
            </CardContent>
          </Card>
        ))}
      </CardGroup>
    </Section>
  );
}
